import configuration from "../../configuration";
import ODataFulogicsStore from "fulogics-ui-core/dist/api/odata/ODataFulogicsStore";
import {createModel} from "@rematch/core";
import {iRootModel} from "../iRootModel";

export const WarehouseODataEndpoint = `${configuration.API_BASE_URL}/odata/Warehouses/Store`;
export const WarehouseStore = ODataFulogicsStore({
    url: WarehouseODataEndpoint,
    key: 'id',
    keyType: 'String'
});

export type WarehouseState = {}

export const WarehouseModel = createModel<iRootModel>()({
    state: {
        
    } as WarehouseState,

    effects: (dispatch) => ({}),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore()
        {
            return WarehouseStore;
        },
    }),
})

export default WarehouseModel;